import { render, staticRenderFns } from "./RegionFeaturedProductsSection.vue?vue&type=template&id=6dca46e8&scoped=true&"
import script from "./RegionFeaturedProductsSection.vue?vue&type=script&lang=js&"
export * from "./RegionFeaturedProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./RegionFeaturedProductsSection.vue?vue&type=style&index=0&id=6dca46e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca46e8",
  null
  
)

export default component.exports